// extracted by mini-css-extract-plugin
export default {"post":"PostList_post__W8VoN","post__btns":"PostList_post__btns__+a+Gw"};